// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"c3103239","387":"76a16e42"}[chunkId] + ".chunk.js";
};